import React from 'react';
import PropTypes from 'prop-types';
import Radio from "../../common/primitives/Radio";
import styles from './PaymentWayRow.scss';
import helpers from '../../common/scss/helpers/_helpers.scss';
import ComponentAutoRenewMessage from "../ComponentAutoRenewMessage/ComponentAutoRenewMessage";
import {__t} from '../../common/lang/text-resource';
import {ConvertToEUR, FormatPrice} from "../../common/primitives/Price";

const PaymentWayRow = ({
						   id,
						   name,
						   selected,
						   available_sum,
						   available_sum_currency,
						   orderTotalSum,
						   onChange,
						   autoRenewChecked,
						   onChangeAutoRenew,
						   hideComponentAutoRenewMessage
					   }) => {
	const customNames = {};

	name = typeof customNames[id] === 'string' ? customNames[id] : name;

	let additionalInfo = '';
	let colorRed = {};
	let canPay = 1;

	if (available_sum_currency !== '') {
		if (SHVO.showEuroPrices) {
			available_sum_currency += ' / ' + FormatPrice(parseFloat(ConvertToEUR(available_sum)), 'EUR');
		}

		additionalInfo = __t('Разполагате с :available_sum_currency', {available_sum_currency: available_sum_currency});
		const avSum = parseFloat(available_sum);

		let s = parseFloat(orderTotalSum);

		canPay = (s <= avSum) && (avSum > 0) && (s > 0);

		if (!canPay) {
			additionalInfo += __t('тъй-като-разполагаемата-сума-е-недостатъчна-за-пл622f1a');
			colorRed = {'color': 'red'};
		}
	}
	return (
	  <div className={`${styles.container} ${selected && styles.selected}`}>
		  <div data-layout="row gutter-none start">
			  <div data-layout="col 1">
				  {canPay && <Radio name={'paymentWay'} value={id} label={''} id={id} checked={selected}
									labelClass={helpers.orderServiceName} onChange={onChange}/>
				  }
			  </div>
			  <div data-layout={`col 2 1@md text-right`}>
				  <label
					htmlFor={id}
					className={`${styles.icon} ${styles[id]}`}>&nbsp;</label>
			  </div>
			  <div data-layout={`col 9 10@md`}>
				  <label className={styles.pwLabel} htmlFor={id}>{name}</label>
				  {
					additionalInfo !== '' &&
					<div style={{whiteSpace: 'normal', marginLeft: '20px', ...colorRed}}>{additionalInfo}</div>
				  }
			  </div>
			  {
				selected === true && (id === 'PAYMENT_FIB' || id === 'PAYMENT_EUR_FIB') && hideComponentAutoRenewMessage === false &&
				<ComponentAutoRenewMessage
				  autoRenewChecked={autoRenewChecked}
				  onChangeAutoRenew={onChangeAutoRenew}/>
			  }
		  </div>
	  </div>
	);
};

PaymentWayRow.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	available_sum: PropTypes.number,
	available_sum_currency: PropTypes.string,
	orderTotalSum: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	onChangeAutoRenew: PropTypes.func,
	selected: PropTypes.bool,
	autoRenewChecked: PropTypes.bool,
	hideComponentAutoRenewMessage: PropTypes.bool
};

export default PaymentWayRow;